import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AbstractVisbosComponent} from '../../../../core/visbos-core/components/abstract-visbos.component';
import {SessionActions} from '../../../../shared/actions';
import {MessageType} from '../../../../shared/redux-store/session';
import {RfidService} from '../../../../identity/services/rfid.service';
import {AssetTree} from '../../../../shared/view-model/store-management/asset-tree.type';
import * as _ from 'lodash';

@Component({
  selector: 'vb-asset-retrieval',
  templateUrl: './asset-retrieval.component.html',
  styleUrls: ['./asset-retrieval.component.css']
})
export class AssetRetrievalComponent extends AbstractVisbosComponent implements OnInit {


  private _assetTree: AssetTree[];

  get assetTree(): AssetTree[] {
    return this._assetTree;
  }

  @Input()
  set assetTree(value: AssetTree[]) {
    this._assetTree = value;
  }

  @Output()
  assetTreeChange: EventEmitter<AssetTree[]> = new EventEmitter();


  private _activeEpcs: string[] = [];

  get activeEpcs(): string[] {
    return this._activeEpcs;
  }

  @Input()
  set activeEpcs(value: string[]) {
    this._activeEpcs = value;
  }

  @Output()
  activeEpcsChange: EventEmitter<string[]> = new EventEmitter<string[]>();

  constructor(sessionActions: SessionActions, cd: ChangeDetectorRef,
              private rfidService: RfidService) {
    super(sessionActions, cd);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  public resolveEPCs(epcs: string[]) {

    if (!epcs || !epcs.length) {
      this.sessionActions.pushMessage("Es wurden keine RFID-Tags erkannt, bitte versuchen Sie es noch einmal!", MessageType.WARNING, "Gegenstands-Erfassung");
      return;
    }

    this.activeEpcs = _.uniq(_.concat(this.activeEpcs, epcs));
    this.activeEpcsChange.emit(this.activeEpcs);

    const locationQuery$ = this.rfidService.resolveAssetTreeFromEPCsOnce({epcs: this.activeEpcs});
    locationQuery$.subscribe(res => {
      this.processResult(res.data.assetTreeByEPCs);
    }, err => {
      this.sessionActions.throwError(err, "Fehler beim Auflösen der EPCs!");
    });
  }

  private processResult(assetTrees: AssetTree[]) {

    if (!assetTrees || !assetTrees.length) {
      this.sessionActions.pushMessage("Die gefundenen EPCs konnten nicht zu Gegenständen aufgelöst werden, bitte versuchen Sie es noch einmal!", MessageType.WARNING, "Gegenstands-Erfassung");
      return;
    }

    this.updateAssetTree(assetTrees);
  }

  updateAssetTree(assetTree: AssetTree[]) {
    this.assetTree = assetTree ? _.cloneDeep(assetTree) : null;
    this.assetTreeChange.emit(this.assetTree);
  }

  getCurrentAssetCuids() {
    return this.assetTree.map((treeNode: AssetTree) => treeNode.cuid);
  }

  reset() {
    this.activeEpcs = [];
    this.activeEpcsChange.emit(this.activeEpcs);
    this.updateAssetTree(null);
  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/asset-management/components/asset-retrieval/asset-retrieval.component.ts